import React from 'react';
import { Images, FileText, Microscope } from 'lucide-react';
import MobileSidebarAccordion from '@/components/ui/MobileSidebarAccordion';
import SidebarHeader from '@/components/ui/SidebarHeader';
import { useIsMobile } from '@/hooks/layout/use-mobile';
import { UniversalContentImporter } from '@/components/shared/import';

interface UniversalMultiselectSidebarProps {
  pageId: string;
  contentType: 'images' | 'research' | 'pages';
  onBulkImport: (selectedIds: string[]) => Promise<void>;
}

const UniversalMultiselectSidebar: React.FC<UniversalMultiselectSidebarProps> = ({
  pageId,
  contentType,
  onBulkImport,
}) => {
  const isMobile = useIsMobile();

  // Get configuration based on content type
  const getContentConfig = () => {
    switch (contentType) {
      case 'pages':
        return {
          title: "Add Documents",
          icon: FileText,
          variant: "purple" as const,
        };
      case 'research':
        return {
          title: "Add Research",
          icon: Microscope,
          variant: "green" as const,
        };
      case 'images':
      default:
        return {
          title: "Add Images",
          icon: Images,
          variant: "blue" as const,
        };
    }
  };

  const config = getContentConfig();

  return (
    <MobileSidebarAccordion
      variant={config.variant}
      persistKey={`multiselect-sidebar-${contentType}`}
      defaultExpanded={!isMobile}
      className="h-full"
    >
      <SidebarHeader 
        title={config.title}
        icon={config.icon} 
        variant={config.variant}
      />
      
      <div className="h-[500px]">
        <UniversalContentImporter
          contentType={contentType}
          projectId={pageId}
          onBulkImport={onBulkImport}
          layout="list"
          showBulkActions={true}
          showSearch={true}
          className="h-full"
        />
      </div>
    </MobileSidebarAccordion>
  );
};

export default UniversalMultiselectSidebar; 